import request from '@/API/';

export default {
  getUserClientBills: (payload) => {
    if(payload) { return request.get(`user/client/bills/${payload}`); }
  },
  fetchOrganisations: (payload) => {
    if(payload) { return request.get(`user/clientlist?q=${payload}`); }
    return request.get(`user/clientlist?s=orgs`);
  },
  getOne: (payload) => {
    return request.get(`user/client/${payload}`);
  },
  createOrganisation: (payload) => {
    return request.post('user/client', payload);
  },
  editOrganisation: (payload) => {
    return request.post('user/editclient', payload);
  },
  getCountries: () => {
    return request.get('user/countries');
  },
  getClientUsage: (payload) => {
    return request.get(`user/client/usage/${payload.c}`);
  },
  getOrganisationDashboard: (payload) => {
    if(!payload.clientHash) return;
    return request.get(
      `data/events/organisation?c=${payload.clientHash}&f=${payload.timeStart}&t=${payload.timeEnd}&q=${0}`
    );
  },
  getAllOrganisationDashboard: (payload) => {
    if(!payload.clientHash) return;
    return request.get(
      `data/events/organisation?c=${payload.clientHash}&f=${payload.timeStart}&t=${payload.timeEnd}&d=${payload.defaultRange}&q=${0}`
    );
  },
  getInterfacesDashboard: (payload) => {
    return request.get(
      `data/events/interface?c=${payload.clientHash}&i=${payload.interfaceID}&f=${payload.timeStart}&t=${payload.timeEnd}`
    );
  },
  getAllRunning() {
    return request.get(`ingest/running`);
  }
};
